import React from "react";
import { FaReact } from "react-icons/fa"; // React icon'u içe aktarma
import "./Vm.css";

interface ICardProps {
  icon: React.ReactNode; // Icon prop'unu ReactNode tipinde tanımlayın
  title: string;
  description: string;
  backgroundColor?: string; // Arka plan rengi için opsiyonel prop
  iconColor?: string; // İkon rengi için opsiyonel prop
}

export const Vm: React.FC<ICardProps> = ({ icon, title, description, backgroundColor, iconColor }) => {
  return (
    <div className="card1 d-flex ">
      <div className="card-icon1" style={{ backgroundColor: backgroundColor }}>
        <div style={{ color: iconColor }}>{icon}</div> {/* Icon burada render ediliyor */}
      </div>
      <div className="card-content1 ms-5">
        <div className="card-title1">{title}</div>
        <div className="card-description1">{description}</div>
      </div>
    </div>
  );
};
